import { FC } from "react";
import { Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next"; // Import useTranslation

import {
  GetTasterExperimentSummaryResponse,
} from "api/client";

import { EmptyData } from "components/common/EmptyData";
import { Tabs } from "components/common/Tabs";
import { ExperimentCard } from "./components/ExperimentCard";

import {
  StyledUpcomingExperiments,
  StyledUpcomingExperimentsList,
  StyledUpcomingExperimentsTabs,
} from "styles/features/home";

interface UpcomingExperimentsProps {
  experiments?: GetTasterExperimentSummaryResponse[];
  activeTab?: string;
  loading?: boolean;

  onTabChange?: (value: string) => void;
  onCardClick?: (id: string) => void;
}

const UpcomingExperiments: FC<UpcomingExperimentsProps> = ({
  experiments,
  activeTab,
  loading,
  onTabChange,
  onCardClick,
}) => {
  const theme = useTheme();
  const { t } = useTranslation(); // Initialize translation

  const tabs = [
    { label: t('all'), value: "all" }, 
    { label: t('need_approval'), value: "need-approval" }, 
    { label: t('approved'), value: "approved" }, 
  ];

  return (
    <StyledUpcomingExperiments>
      <Typography variant="h2" color={theme.palette.common.black}>
        {t('upcoming_experiments')} 
      </Typography>
      <StyledUpcomingExperimentsTabs>
        <Tabs tabs={tabs} value={activeTab} onChange={onTabChange} />
      </StyledUpcomingExperimentsTabs>
      <StyledUpcomingExperimentsList>
        {experiments && experiments.length > 0 ? (
          experiments.map((experiment) => (
            <ExperimentCard
              key={experiment.id}
              experiment={experiment}
              onClick={() => onCardClick?.(experiment.id)}
            />
          ))
        ) : (
          <EmptyData
            isLoading={loading}
            text={t('no_upcoming_experiments')} 
            direction="column"
          />
        )}
      </StyledUpcomingExperimentsList>
    </StyledUpcomingExperiments>
  );
};

export default UpcomingExperiments;
